import React from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { change } from 'redux-form'
import { ICONS } from '../../../../components'

export const CATEGORY_CHOICES = [
  { code: 'ios', text: 'iPhone / iPad / Watch / Accessories' },
  { code: 'mac', text: 'MacBook / Mac / MacPro' },
  { code: 'delivery', text: 'Delivery / Shipping' },
]

const FORM_NAME = 'token-entry-form'

export const CategorySelector = ({ selected }: { selected: string }) => {
  const dispatch = useDispatch()

  const handleSelect = (code: string) => {
    dispatch(change(FORM_NAME, 'category', code))
  }

  return (
    <div className="category-selector-container mb-4">
      <h6 className="text-left pl-4">What do you need help with?</h6>
      <Row xs={1} sm={2} md={3} className="g-3">
        {CATEGORY_CHOICES.map((choice) => {
          const isSelected = selected === choice.code
          return (
            <Col key={choice.code}>
              <Button
                variant={isSelected ? 'dark' : 'light'}
                onClick={() => handleSelect(choice.code)}
                className={`w-100 h-100 p-3 border ${
                  isSelected ? 'border-dark text-white' : 'border-secondary text-dark'
                } d-flex flex-column justify-content-center align-items-center shadow-sm rounded`}
                style={{
                  minHeight: '120px',
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
                  {isSelected ? ICONS.CHECK_CIRCLE : ICONS.PLUS_CIRCLE}
                </div>
                <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>{choice.text}</span>
              </Button>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}
